import React from 'react';
import ProductRoute from './ProductRoute';
import CategoryRoute from './CategoryRoute';
import ContentRoute from './ContentRoute';
import get from 'lodash.get';
import Status from './Status';
import { Redirect } from 'react-router';
const isRouteType = (state, result, type) => {
    if (result.error) {
        return false;
    }
    const stateType = get(state, 'type');
    const routeType = get(result, 'data.route.object.__typename');
    return stateType === type || routeType === type;
};
const isEmptyRoute = (result) => {
    const errorCode = get(result, 'error.graphQLErrors[0].extensions.code', '');
    const route = get(result, 'data.route');
    return errorCode.includes('EmptyRoute') || !route;
};
const Loading = (LoadingPage) => LoadingPage ? React.createElement(LoadingPage, null) : React.createElement("div", null, "Loading...");
const RouteResolver = ({ productPage, categoryPage, contentPage, notFoundPage: NotFoundPage, ErrorPage, LoadingPage, result, pathname, state, search }) => {
    if (get(result, 'data.route.path', pathname) !== pathname) {
        return (React.createElement(Status, { code: 301 },
            React.createElement(Redirect, { to: {
                    pathname: result.data.route.path,
                    state,
                    search
                } })));
    }
    else if (isRouteType(state, result, 'Product')) {
        return React.createElement(ProductRoute, { result: result, component: productPage });
    }
    else if (isRouteType(state, result, 'Category')) {
        return React.createElement(CategoryRoute, { result: result, component: categoryPage });
    }
    else if (isRouteType(state, result, 'Page')) {
        return (React.createElement(ContentRoute, { pathname: pathname, result: result, component: contentPage }));
    }
    else if (result.loading) {
        return Loading(LoadingPage);
    }
    else {
        if (isEmptyRoute(result)) {
            return (React.createElement(Status, { code: 404 },
                React.createElement(NotFoundPage, null)));
        }
        return (React.createElement(Status, { code: 500, error: result.error }, ErrorPage ? (React.createElement(ErrorPage, { error: result.error })) : (React.createElement("div", null,
            "Error: ",
            JSON.stringify(result.error),
            "."))));
    }
};
export default RouteResolver;
//# sourceMappingURL=RouteResolver.js.map